import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useWeb3 } from '../context/Web3Context';
import { Shield, Map, Home, AlertTriangle, Users, Bot, Sun, Moon, Menu, X, Wallet as WalletIcon, User, BookOpen } from 'lucide-react';
import '../styles/global.css';

const Navbar = () => {
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const { account, connectWallet, formatAddress, isConnecting } = useWeb3();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const NavItem = ({ to, icon: Icon, label }) => (
    <Link 
      to={to} 
      className={isActive(to) ? "nav-link active" : "nav-link"}
      onClick={() => setIsMobileMenuOpen(false)}
      style={{ color: isActive(to) ? 'var(--primary)' : 'var(--text-muted)' }}
    >
      <Icon size={18} />
      <span>{label}</span>
    </Link>
  );

  return (
    <>
      <nav className="glass-panel" style={{ 
        position: 'fixed', top: 0, left: 0, right: 0, 
        height: '70px', padding: '0 5%', zIndex: 1000, 
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderRadius: '0 0 16px 16px', borderTop: 'none', borderLeft: 'none', borderRight: 'none',
        background: 'var(--nav-bg)'
      }}>
        
        {/* Brand - UPDATED NAME */}
        <Link to="/" style={{ display: 'flex', gap: 10, alignItems: 'center', textDecoration:'none', color:'var(--text-main)' }}>
          <div style={{ background: 'rgba(139, 92, 246, 0.2)', padding: '8px', borderRadius: '12px' }}>
            <Shield color="#8b5cf6" fill="#8b5cf6" size={24} /> 
          </div>
          <span style={{ fontSize: '1.25rem', fontWeight: '700', letterSpacing: '-0.5px' }}>StakeStreet</span>
        </Link>

        {/* Desktop Nav */}
        <div className="desktop-nav" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <NavItem to="/" icon={Home} label="Home" />
          <NavItem to="/map" icon={Map} label="Live Map" />
          <NavItem to="/report" icon={AlertTriangle} label="Report" />
          <NavItem to="/community" icon={Users} label="Community" />
          <NavItem to="/how-to-use" icon={BookOpen} label="How to Use" />
          <NavItem to="/ai-assistant" icon={Bot} label="AI Assistant" />
        </div>

        {/* Right Side Actions */}
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          
          <button onClick={toggleTheme} className="icon-btn" style={{ color: 'var(--text-main)' }}>
            {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
          </button>

          {/* WEB3 CONNECT BUTTON */}
          {account ? (
            <div className="glass-panel" style={{
              padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '8px',
              border: theme === 'light' ? '1px solid #7c3aed' : '1px solid #8b5cf6', 
              background: theme === 'light' ? 'rgba(124, 58, 237, 0.1)' : 'rgba(139, 92, 246, 0.1)', 
              cursor: 'default'
            }}>
              <div style={{width: 8, height: 8, background: '#10b981', borderRadius: '50%'}}></div>
              <span style={{ 
                fontSize: '0.9rem', 
                color: theme === 'light' ? '#6d28d9' : '#8b5cf6', 
                fontWeight: 'bold', fontFamily: 'monospace' 
              }}>
                {formatAddress(account)}
              </span>
            </div>
          ) : (
            <button 
              onClick={connectWallet}
              className="btn-primary" 
              style={{ padding: '8px 20px', display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <WalletIcon size={18} />
              {isConnecting ? "Connecting..." : "Connect Wallet"}
            </button>
          )}

          {user && (
            <Link to="/profile" className="icon-btn" title="My Profile" style={{ textDecoration: 'none', color: 'var(--text-main)' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: 'var(--glass-border)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <User size={18} />
              </div>
            </Link>
          )}

          <button className="mobile-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} style={{ color: 'var(--text-main)' }}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="glass-panel" style={{
          position: 'fixed', top: '80px', left: '20px', right: '20px',
          zIndex: 999, padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px',
          background: 'var(--nav-bg)'
        }}>
          <NavItem to="/" icon={Home} label="Home" />
          <NavItem to="/map" icon={Map} label="Live Map" />
          <NavItem to="/report" icon={AlertTriangle} label="Report" />
          <NavItem to="/community" icon={Users} label="Community" />
          <NavItem to="/how-to-use" icon={BookOpen} label="How to Use" />
          <NavItem to="/ai-assistant" icon={Bot} label="AI Assistant" />
          
          {!account && (
            <button onClick={() => { connectWallet(); setIsMobileMenuOpen(false); }} className="btn-primary" style={{ marginTop: '10px' }}>
              Connect Wallet
            </button>
          )}
          {user && <NavItem to="/profile" icon={User} label="My Profile" />}
        </div>
      )}
    </>
  );
};

export default Navbar;